
import { mapActions, mapGetters } from 'vuex'

export default {
  name: 'TheCartExerpt',
  computed: {
    ...mapGetters('cart', ['itemsSubtotalPrice', 'itemsByStore'])
  },
  methods: {
    ...mapActions(['closeCart']),
    emptyCart() {
      this.$store.commit('cart/emptyCart')
    },
    goToCart() {
      this.closeCart()
      this.$router.push(this.localePath('cart'))
    }
  }
}
